<div class="digit-container">
  <h1>Mobile Verification</h1>
  <p class="mb-3 mt-3">{{'verify-msg' | language}}</p>
  <ng-otp-input  (onInputChange)="onOtpChange($event)"  [config]="{inputClass: 'q-input-large', containerClass: 'otp-container', inputStyles: {'font-size': '28px', 'height': 'auto', 'width': '48px'}, allowNumbersOnly: true, length:4}"></ng-otp-input>
  <p *ngIf="error" class="err-txt">{{errorMsg}}</p>
  <button mat-raised-button class="primary-btn mt-5" (click)="submit()">{{'continue' | language}}</button>
</div>
